import { Check, Wallet } from "lucide-react";

import { PERMISSOES_CAIXA } from "../lib/permissoes";

/** Bloco "Caixa" do cadastro de funcionário: o que ele pode fazer no caixa. */
export default function PermissoesCaixa({ selecionadas, onToggle }) {
  return (
    <div className="border rounded-xl p-4 bg-muted/20" data-e2e="permissoes-caixa">
      <div className="mb-3">
        <p className="text-sm font-semibold flex items-center gap-1.5"><Wallet className="w-4 h-4 text-primary" />Caixa</p>
        <p className="text-[11px] text-muted-foreground">O que este funcionário pode fazer no caixa. Dono e administrador sempre podem tudo.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        {PERMISSOES_CAIXA.map((p) => {
          const ligada = selecionadas.includes(p.id);
          return (
            <button key={p.id} type="button" onClick={() => onToggle(p.id)} data-e2e={`perm-${p.id}`}
              className={`flex items-center justify-between gap-2 px-3 py-2 rounded-lg border text-left transition-all ${ligada ? "border-primary bg-primary/5 hover:bg-primary/10" : "border-border bg-background hover:border-muted-foreground/40"}`}>
              <div className="flex-1 min-w-0">
                <p className={`text-sm font-medium ${ligada ? "text-foreground" : "text-muted-foreground"}`}>{p.label}</p>
                <p className="text-[10px] text-muted-foreground">{p.hint}</p>
              </div>
              <div className={`w-5 h-5 rounded border-2 flex items-center justify-center shrink-0 ${ligada ? "border-primary bg-primary" : "border-muted-foreground/40"}`}>
                {ligada && <Check className="w-3 h-3 text-white" strokeWidth={3} />}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
